export default {
  "first-automation": "First Automation",
  "authenticated-automations": {
    display: "hidden",
  },
  "example-github-repo": "Example GitHub Repo",
};
